import { Theme, ThemeOptions } from "@mui/material";
import { typographyStyle } from "./styles/typographyStyle";
import { muiPickerYearStyle } from "./styles/muiPickerYearStyle.ts";
import { muiPickerDayStyle } from "./styles/muiPickerDayStyle.ts";
import { muiTimePickerToolbarStyle } from "./styles/muiTimePickerToolbarStyle.ts";
import { muiButtonStyle } from "./styles/muiButtonStyle.ts";
import { muiChipStyle } from "./styles/muiChipStyle.ts";
import { muiFabStyle } from "./styles/muiFabStyle.ts";
import { muiLinkStyle } from "./styles/muiLinkStyle.ts";
import { muiFormLabelStyle } from "./styles/muiFormLabelStyle.ts";
import { muiFormHelperTextStyle } from "./styles/muiFormHelperTextStyle.ts";
import { muiFormControlLabelStyle } from "./styles/muiFormControlLabelStyle.ts";
import { muiDialogStyle } from "./styles/muiDialogStyle";
import { muiPaperStyle } from "./styles/muiPaperStyle.ts";
import { muiAlertStyle } from "./styles/muiAlertStyle.tsx";
import { muiCardStyle } from "./styles/muiCardStyle.ts";
import { muiDialogTitleStyle } from "./styles/muiDialogTitleStyle.ts";
import { muiSwitchStyle } from "./styles/muiSwitchStyle.ts";
import { muiOutlinedInputStyle } from "./styles/muiOutlinedInputStyle.ts";
import { muiCssBaselineStyle } from "./styles/muiCssBaselineStyle.ts";
import { muiDialogContentStyle } from "./styles/muiDialogContentStyle.ts";
import { muiDialogActionStyle } from "./styles/muiDialogActionStyle.ts";

export const darkModePalette: ThemeOptions["palette"] = {
  mode: "dark",
  iconColor: {
    main: "#FFFFFF",
  },
  primary: {
    light: "#4b9f9c",
    main: "#137F7B",
    dark: "#0B504C",
    contrastText: "rgb(255, 255, 255)",
  },
  primaryPale: "#DDEBEB",
  secondary: {
    light: "#017b88",
    main: "#015b58",
    dark: "#013b39",
    contrastText: "rgb(255, 255, 255)",
  },
  buttonGrey: {
    main: "#e0e0e0",
    dark: "#d5d5d5",
    contrastText: "rgba(0, 0, 0, 0.86)",
  },
  buttonText: {
    main: "#f4f4f4",
  },
  text: {
    primary: "#f4f4f4",
    secondary: "#F4F4F4",
    light: "#999999",
    contrast: "#333333",
  },
  background: {
    default: "#000000",
    contrast: "#f4f4f4",
    medium: "#666666",
    light: "#333333",
  },
};

export const lightModePalette: ThemeOptions["palette"] = {
  mode: "light",
  iconColor: {
    main: "#333333",
  },
  primary: {
    light: "#7FB7B5",
    main: "#137F7B",
    dark: "#046562",
    contrastText: "#fff",
  },
  primaryPale: "#DDEBEB",
  secondary: {
    light: "#EFB080",
    main: "#E99351",
    dark: "#DB7304",
    contrastText: "#333",
  },
  buttonGrey: {
    main: "#e0e0e0",
    dark: "#d5d5d5",
    contrastText: "rgba(0, 0, 0, 0.86)",
  },
  buttonText: {
    main: "#333",
  },
  text: {
    primary: "#333",
    secondary: "#525252",
    light: "#999999",
    contrast: "#d0e7e6",
    disabled: "#8F8F8F",
  },
  background: {
    default: "#fff",
    contrast: "#f7f7f7",
    medium: "#666666",
    light: "#F5F8F8",
  },
  brand: {
    steel: "#CFD8DC",
    frost: "#ECF3FE",
  },
  divider: "#CFD8DC",
  gradients: {
    charcoal: "linear-gradient(223deg, #71878B 3.63%, #1E2425 100%)",
    blackFade: "linear-gradient(to top, #000000FF 0%, #00000000 100%)",
    glacial: "linear-gradient(180deg, #FFF 0%, #BCD7D6 136.61%)",
  },
  success: {
    main: "#04673A",
    light: "#DBEDE5",
    dark: "#024828",
  },
  warning: {
    main: "#AB4F02",
    light: "#F9EDE3",
    dark: "#773701",
  },
  error: {
    main: "#C20303",
    light: "#F5E0E1",
    dark: "#870202",
  },
};

export const getBaseThemeOptions = (theme: Theme): ThemeOptions => {
  return {
    typography: typographyStyle(theme),
    components: {
      MuiCssBaseline: muiCssBaselineStyle(),
      MuiPickerYear: muiPickerYearStyle(),
      MuiPickerDay: muiPickerDayStyle(),
      MuiTimePickerToolbar: muiTimePickerToolbarStyle(),
      MuiButton: muiButtonStyle(),
      MuiChip: muiChipStyle(theme),
      MuiFab: muiFabStyle(),
      MuiLink: muiLinkStyle(),
      MuiFormLabel: muiFormLabelStyle(),
      MuiFormHelperText: muiFormHelperTextStyle(),
      MuiFormControlLabel: muiFormControlLabelStyle(),
      MuiDialog: muiDialogStyle(theme),
      MuiDialogTitle: muiDialogTitleStyle(),
      MuiDialogContent: muiDialogContentStyle(),
      MuiDialogActions: muiDialogActionStyle(),
      MuiPaper: muiPaperStyle(),
      MuiAlert: muiAlertStyle(),
      MuiCard: muiCardStyle(),
      MuiSwitch: muiSwitchStyle(),
      MuiOutlinedInput: muiOutlinedInputStyle(),
    },
  };
};
